import React from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { useConfigureInSolarAnalytics } from '../../dashboard/use-configure-in-solar-analytics';
import { useSite } from '../siteApi';

export const MeterConfigureActionMenu = () => {
  const { site } = useSite();
  const navigate = useNavigate();
  const { siteHasSolarAnalyticsMeter, handleConfigureInSolarAnalytics } = useConfigureInSolarAnalytics(
    site.meters ?? []
  );

  // If there is no Solar Analytics meter, we only show the Configure Circuits button
  if (!siteHasSolarAnalyticsMeter)
    return (
      <Button
        variant={'ghost'}
        rightIcon={<ChevronRightIcon />}
        data-testid="configure-circuits-btn"
        onClick={() => navigate(`/site/${site.clipsal_solar_id}/meter_setup/configure/circuit_appliance_configuration`)}
      >
        Configure Circuits
      </Button>
    );

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronRightIcon />} variant={'ghost'} data-testid="configure-menu-btn">
        Configure
      </MenuButton>
      <MenuList>
        <MenuItem
          as={Button}
          variant={'ghost'}
          rightIcon={<ChevronRightIcon />}
          data-testid="configure-circuits-btn"
          onClick={() =>
            navigate(`/site/${site.clipsal_solar_id}/meter_setup/configure/circuit_appliance_configuration`)
          }
        >
          Appliances & Circuits
        </MenuItem>

        {siteHasSolarAnalyticsMeter && (
          <MenuItem
            as={Button}
            variant={'ghost'}
            rightIcon={<ChevronRightIcon />}
            data-testid="visit-solar-analytics-btn"
            onClick={handleConfigureInSolarAnalytics}
          >
            Visit Solar Analytics
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};
